import React, { useState } from "react"
import ReactCardFlip from "react-card-flip"
import { SlideCard, SlideContent, SlideButton } from "./styles"
import { renderHTML } from "../../agility/utils"
import Img from "gatsby-image"

const Card = ({ member }) => {
  // flipped card state
  const [flipped, setFlipped] = useState(false)

  // handle flip function
  const handleFlip = e => {
    e.preventDefault()
    setFlipped(!flipped)
  }
  return (
    <ReactCardFlip isFlipped={flipped}>
      <SlideCard>
        <SlideContent>
          <Img
            fluid={member.customFields.imageLocalImg.childImageSharp.fluid}
            alt={member.customFields.name}
          />
          <h6>{member.customFields.name}</h6>
          <p>{member.customFields.position}</p>
        </SlideContent>
        <SlideButton>
          <button onClick={handleFlip}>
            <p>{flipped === true ? "Less" : "More"}</p>
            <p>{flipped === true ? "-" : "+"}</p>
          </button>
        </SlideButton>
      </SlideCard>
      <SlideCard>
        <div
          className="card-bio"
          dangerouslySetInnerHTML={renderHTML(member.customFields.bio)}
        />
        <button onClick={handleFlip}>
          <p>{flipped === true ? "Less" : "More"}</p>
          <p>{flipped === true ? "-" : "+"}</p>
        </button>
      </SlideCard>
    </ReactCardFlip>
  )
}

export default Card
